// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"38a7eddf","453":"1eccdecd","455":"ab6620be","977":"0f31b31f"}[chunkId] + ".chunk.js";
};